import { NearbyFacility, BffFacility } from '@/graphql/__generated/sdk';

import { brandThemeToFacilityBrand } from './brandThemeToFacilityBrand';
import { getBffNearByFacilitiesByLocation } from './getBffNearByFacilitiesByLocation';
import { FacilitiesLoadingConfig } from './useFacilitiesSSR';

import { BffBrandType } from '@shared-components/gqlConstants';
import { mapFacilities } from '@utils/mapFacilitiesResults';

export async function getNearbyFacilitiesFromLocation({
	coords,
	config,
}: {
	coords: { latitude: number; longitude: number };
	config: FacilitiesLoadingConfig;
}) {
	let facilities: NearbyFacility[] = [];
	let nearbyFacilities: BffFacility[] | null = null;

	if (!coords.latitude && !coords.longitude) {
		return {
			facility: undefined,
			facilities: [],
			nearbyFacilities: null,
		};
	}
	const res = await getBffNearByFacilitiesByLocation(
		brandThemeToFacilityBrand(config.brand).toString() as BffBrandType,
		coords.latitude || 0,
		coords.longitude || 0,
		config.bffGraphqlUrl,
		config.appName,
		config.appVersion
	);
	facilities = mapFacilities(res?.facilityByLocation);
	nearbyFacilities =
		res?.facilityByLocation?.filter((facility): facility is BffFacility => facility !== null) ?? null;

	const facility = facilities?.[0]?.facility ?? null;
	return {
		facility,
		facilities,
		nearbyFacilities,
	};
}
